import React from 'react';
import classnames from 'classnames';
import { format as formatDate, parse as parseDate, eachMonthOfInterval, startOfYear, addYears, getMonth, startOfMonth, getYear, addMonths, startOfDay, endOfDay, } from 'date-fns';
import { toast } from 'react-toastify';
import { omit, sumBy, keyBy, sortBy, groupBy, pickBy, get, sum } from 'lodash';
import { useToggle } from 'react-use';
import numeral from 'numeral';

import { boxSizesForCount, amazonProductSizeTypes, } from '../shared/config';
import { setSizes, documentNumberHavings, } from '../shared/models/receivingRequest';

const { entries, keys } = Object;

export default function UseCountDetail(props) {
  const { tenant, useCount, productsById, showsSku = false, } = props;
  const idWithTenant = _ => [tenant.id, _].join('-');
  const { receivingRequestOptionCounts, shippingRequestOptionCounts, combiningCounts = {}, shippingRequestsCount, shippingRequestBoxCounts, toBeShippingRequestBoxCounts = {}, unknownReceivingRequestCount, storageDays, receivingCount, shelvingCounts, extraPickingsCount, unknownInventoriesCount, amazonShipmentItemsCount, } = useCount;

  return (
    <div className="overflow-auto">
      <table className="table table-bordered">
        <thead className="thead-light text-center">
          <tr>
            <th colSpan={10}>オプション</th>
            <th rowSpan={2}>加工件数</th>
            <th rowSpan={2}>完了出荷依頼数</th>
            <th rowSpan={2}>出荷件数</th>
            <th rowSpan={2}>toB出荷件数</th>
            <th rowSpan={2}>不明件数</th>
            <th rowSpan={2}>不明件数(箱)</th>
            <th rowSpan={2}>保管日数</th>
            <th rowSpan={2}>入荷件数</th>
            <th rowSpan={2}>入庫点数</th>
            <th rowSpan={2}>追加ピッキング数</th>
            <th rowSpan={2}>Amazon納品数</th>
          </tr>
          <tr>
            <th>追加検品</th>
            <th>加工</th>
            <th>OPP梱包(入)</th>
            <th>納品書・明細書確認保管</th>
            <th>OPP梱包(出)</th>
            <th>プチプチ梱包</th>
            <th>チラシ同封</th>
            <th>添付ファイルの印刷同封</th>
            <th>納品書同封</th>
            <th>着払いで出荷</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="">
              {
                entries(receivingRequestOptionCounts.check).map(([id, value]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                keys(setSizes).map((setSize) => {
                  const value = sumBy(Object.values(receivingRequestOptionCounts.set), setSize);
                  return value ? (
                    <div key={setSize} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {setSizes[setSize].label}
                      </div>
                      {
                        entries(receivingRequestOptionCounts.set).map(([id, values]) => {
                          const value = values[setSize];
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="">
              {
                entries(receivingRequestOptionCounts.opp).map(([id, value]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                (receivingRequestOptionCounts.keepDocuments || []).map((id) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                keys(boxSizesForCount).map((boxSize) => {
                  const value = sumBy(Object.values(shippingRequestOptionCounts.opp), boxSize);
                  return value ? (
                    <div key={boxSize} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {boxSizesForCount[boxSize].label}
                      </div>
                      {
                        entries(shippingRequestOptionCounts.opp).map(([id, values]) => {
                          const value = values[boxSize];
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="">
              {
                keys(boxSizesForCount).map((boxSize) => {
                  const value = sumBy(Object.values(shippingRequestOptionCounts.puchi), boxSize);
                  return value ? (
                    <div key={boxSize} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {boxSizesForCount[boxSize].label}
                      </div>
                      {
                        entries(shippingRequestOptionCounts.opp).map(([id, values]) => {
                          const value = values[boxSize];
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="">
              {
                entries(shippingRequestOptionCounts.flyer).map(([id, values]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                entries(shippingRequestOptionCounts.print).map(([id, values]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                entries(shippingRequestOptionCounts.slip || {}).map(([id, values]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                entries(shippingRequestOptionCounts.cashOnDelivery).map(([id, values]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}({sum(Object.values(values))})</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                keys(boxSizesForCount).map((boxSize) => {
                  const value = sum(Object.values(combiningCounts?.[boxSize] || {}));
                  return value ? (
                    <div key={boxSize} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {boxSizesForCount[boxSize].label}
                      </div>
                      {
                        entries(combiningCounts?.[boxSize] || {}).map(([id, value]) => {
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(id)}({numeral(value).format()})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="text-right">
              {numeral(shippingRequestsCount).value()}
            </td>
            <td className="">
              {
                keys(boxSizesForCount).map((boxSize) => {
                  const value = sumBy(Object.values(shippingRequestBoxCounts), boxSize);
                  return value ? (
                    <div key={boxSize} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {boxSizesForCount[boxSize].label}
                      </div>
                      {
                        entries(shippingRequestBoxCounts).map(([id, values]) => {
                          const value = values[boxSize];
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="">
              {
                keys(boxSizesForCount).map((boxSize) => {
                  const value = sumBy(Object.values(toBeShippingRequestBoxCounts), boxSize);
                  return value ? (
                    <div key={boxSize} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {boxSizesForCount[boxSize].label}
                      </div>
                      {
                        entries(toBeShippingRequestBoxCounts).map(([id, values]) => {
                          const value = values[boxSize];
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="">
              {
                unknownReceivingRequestCount.map((id) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                entries(unknownInventoriesCount || {}).map(([id, value]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}({numeral(value).format()})</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                keys(boxSizesForCount).map((boxSize) => {
                  const value = sum(Object.values(storageDays?.[boxSize] || {}));
                  return value ? (
                    <div key={boxSize} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {boxSizesForCount[boxSize].label}
                      </div>
                      {
                        entries(storageDays?.[boxSize] || {}).map(([productId, value]) => {
                          const label = showsSku ? productsById[productId]?.sku : idWithTenant(productId);
                          return value ? (
                            <div className="text-nowrap">{label}({numeral(value).format()})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="">
              {
                keys(documentNumberHavings).map((documentNumberHaving) => {
                  const value = Object.values(receivingCount?.[documentNumberHaving] || {}).length;
                  return value ? (
                    <div key={documentNumberHaving} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {documentNumberHavings[documentNumberHaving].label}
                      </div>
                      {
                        (receivingCount?.[documentNumberHaving] || []).map((receivingRequestId) => {
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(receivingRequestId)}</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
            <td className="">
              {
                entries(shelvingCounts || {}).map(([receivingRequestId, counts]) => {
                  return (
                    <div className="mb-3">
                      <div className="font-weight-bold text-nowrap">{idWithTenant(receivingRequestId)}</div>
                      {
                        entries(counts).map(([productId, count]) => {
                          return (
                            <div className="text-nowrap ml-3">{idWithTenant(productId)}({count})</div>
                          );
                        })
                      }
                    </div>
                  );
                })
              }
            </td>
            <td className="">
              {
                entries(extraPickingsCount || {}).map(([id, value]) => {
                  return (
                    <div className="text-nowrap">{idWithTenant(id)}({numeral(value).format()})</div>
                  );
                })
              }
            </td>
            <td className="">
              {
                keys(amazonProductSizeTypes).map((amazonProductSizeType) => {
                  const value = sumBy(Object.values(amazonShipmentItemsCount || {}), amazonProductSizeType);
                  return value ? (
                    <div key={amazonProductSizeType} className="text-nowrap mb-3">
                      <div className="font-weight-bold">
                        {amazonProductSizeTypes[amazonProductSizeType].label}
                      </div>
                      {
                        entries(amazonShipmentItemsCount || {}).map(([id, values]) => {
                          const value = values[amazonProductSizeType];
                          return value ? (
                            <div className="text-nowrap">{idWithTenant(id)}({value})</div>
                          ) : null;
                        })
                      }
                    </div>
                  ) : null;
                })
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
